import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
import "bootstrap-daterangepicker/daterangepicker.css"; // Import Date Range Picker CSS
import "bootstrap-daterangepicker"; // Import Date Range Picker JS
import moment from "moment";
import ContentHeader from "../../../Components/ContentHeader/ContentHeader";
import Form from "../../../Components/Form/Form";
function CreateAuditsImagesUi({
  formik,
  id,
  handleTitleChange,
  addNewTitleField,
  removeTitleField,
  isTitleError,
  toast
}) {
  return (
    <div className="content-wrapper" style={{ minHeight: "100vh" }}>
      {/* Content Header */}
      <ContentHeader
        title={id ? "Update Audit Images" : "Create Audit Images"}
        buttonName={""}
        buttonBoolean={false}
        pageName={id ? "Update Audit Images" : "Create Audit Images"}
        backButton={true}
      />
      <div style={{ padding: "0.8rem" }}>
      <Form formik={formik} toast={toast}>
        <div className="form-group">
          <label htmlFor="cens">Image Title:</label>
          <div>
            {formik?.values?.titles?.map((cen, index) => (
              <div key={index}>
                <div className="d-flex align-items-center mb-2">
                  <input
                    type="text"
                    name={`titles[${index}]`}
                    value={cen}
                    placeholder="Enter Image Title"
                    className="form-control mr-2"
                    onChange={(e) => handleTitleChange(index, e.target.value)}
                    onInput={(e) => {
                      const value = e.target.value;
                      e.target.value = value.slice(0, 250); // Limit to 10 digits
                    }}
                  />
                  {!id && (
                    <>
                      {formik?.values?.titles?.length > 1 && (
                        <button
                          type="button"
                          className="btn btn-danger"
                          onClick={() => removeTitleField(index)}
                        >
                          -
                        </button>
                      )}
                      <button
                        type="button"
                        className="btn btn-success ml-2"
                        onClick={addNewTitleField}
                      >
                        +{" "}
                      </button>
                    </>
                  )}
                </div>
                {/* {formik.errors.cens && formik.touched.cens && ((isArray(formik.errors?.cens) && index in formik.errors?.cens) || (!isArray(formik.errors?.cens) && formik.errors?.cens))&& (
                                <div className="select-error">{isArray(formik.errors?.cens) ? formik.errors?.cens[index] : formik.errors?.cens}</div>
                            )} */}
              </div>
            ))}
            <div className="select-error">{isTitleError}</div>
          </div>
        </div>
     
      </Form>
      </div>
    </div>
  );
}

export default CreateAuditsImagesUi;
